import { type ColorType } from '@wf/components';

function getProbabilityTagColor(percent: number): ColorType {
  if (percent <= 30) {
    return 'error';
  }

  if (percent <= 70) {
    return 'caution';
  }

  return 'success';
}

export default getProbabilityTagColor;
